export default {"src":"/_next/static/media/syn.042f8cd0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};